import { render, staticRenderFns } from "./PatientsTable.vue?vue&type=template&id=1efd7c2e&scoped=true&"
import script from "./PatientsTable.vue?vue&type=script&lang=js&"
export * from "./PatientsTable.vue?vue&type=script&lang=js&"
import style0 from "./PatientsTable.vue?vue&type=style&index=0&id=1efd7c2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd7c2e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
